'use strict';


export default function() {
	return {
		link: postLink,
	}

	function postLink(scope) {
		scope.levelFilter = function(level) {
			return function(logEntry) {
				return logEntry.level >= level;
			};
		};
	}
}
